import { Link, useSearchParams } from "react-router-dom";

const CampaignReturnLink = () => {
  const [searchParams] = useSearchParams();

  if (searchParams.get("from") !== "wave") return null;

  return (
    <Link
      to="/wave"
      className="inline-flex min-h-[44px] max-w-full items-center rounded-full px-1 text-sm font-semibold text-wave underline underline-offset-4 break-words focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wave focus-visible:ring-offset-2"
    >
      <span aria-hidden className="mr-1 shrink-0">←</span>
      <span>Back to the Wave campaign</span>
    </Link>
  );
};

export default CampaignReturnLink;